const STORAGE_KEY = 'structural_workspace';

export function getStoredWorkspace() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.workspaceId) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function getStoredWorkspaceId() {
  return getStoredWorkspace()?.workspaceId ?? null;
}

export function setStoredWorkspace({ workspaceId, displayName, usernameSlug }) {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      workspaceId,
      displayName: displayName || '',
      usernameSlug: usernameSlug || '',
    }),
  );
}

export function clearStoredWorkspace() {
  localStorage.removeItem(STORAGE_KEY);
}
